module.exports = __webpack_public_path__ + "static/img/d-attract.3d1efc29.png";